@if (details().error) {
    <div class="text-large leading-relaxed mb-3 text-red">{{ details().error }}</div>
} @else {
    <div class="text-large leading-relaxed mb-3">
        <div class="mt-2">Updates for <span class="text-bold">{{details().current_name}}</span>:</div>
        @if (details().rename_to) {
            <div class="mt-2"><span class="text-bold">Rename to:</span> {{ details().rename_to }}</div>
        }
        @if (details().added_symbols.length) {
            <div class="mt-2">
                <span class="text-bold">Adding ({{ details().added_symbols.length }}):</span>
                {{ details().added_symbols.join(', ') }}
            </div>
        }
        @if (details().removed_symbols.length) {
            <div class="mt-2">
                <span class="text-bold">Removing ({{ details().removed_symbols.length }}):</span>
                {{ details().removed_symbols.join(', ') }}
            </div>
        }
    </div>
}
